
// SCRIPTS
import { GeneralHomePage } from './home/home.page'; export { GeneralHomePage };
import { DataStandardsContent } from './data-standards/data-standards-content'; export { DataStandardsContent };


// STYLES
import './home/home.scss';
import './data-standards/data-standards-content.scss';


